module.exports = __webpack_public_path__ + "static/media/job-1.9441ae0d.png";